
// import React, { useState, useEffect } from "react";
// import "./Customer.css";
// import HeaderTitle from "../HederTitle/HeaderTitle";
// import axios from "axios";
// import { backend_url } from "../../App";

// const Customer = () => {
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [reviews, setReviews] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchReviews = async () => {
//       try {
//         const response = await axios.get(`${backend_url}/api/customerreview`);
//         const filteredReviews = response.data.filter(review => review.showReview === true);
//         setReviews(filteredReviews);
//         setLoading(false);
//       } catch (err) {
//         setError("Failed to fetch reviews");
//         setLoading(false);
//         console.error("Error fetching reviews:", err);
//       }
//     };

//     fetchReviews();
//   }, []);

//   const handlePrev = () => {
//     setCurrentIndex((prevIndex) =>
//       prevIndex === 0 ? reviews.length - 1 : prevIndex - 1
//     );
//   };

//   const handleNext = () => {
//     setCurrentIndex((prevIndex) =>
//       prevIndex === reviews.length - 1 ? 0 : prevIndex + 1
//     );
//   };

//   if (loading) return <div className="loading">Loading testimonials...</div>;
//   if (error) return <div className="error">{error}</div>;
//   if (reviews.length === 0) return <div className="no-reviews">No testimonials available</div>;

//   const currentReview = reviews[currentIndex];

//   return (
//     <>
//       <HeaderTitle Header="What Customer's Say About Us" />
//       <div className="customer-container">
//         <div className="testimonial-card">
//           {currentReview.reviewImage && (
//             <img loading="lazy" crossOrigin="anonymous"  
//               src={currentReview.reviewImage} 
//               alt={currentReview.name} 
//               className="customer-image" 
//               onError={(e) => {
//                 e.target.src = "https://via.placeholder.com/150?text=Customer";
//               }}
//             />
//           )}
//           <div className="testimonial-content">
//             <div className="rating">
//               {[...Array(5)].map((_, i) => (
//                 <span 
//                   key={i} 
//                   className={`star ${i < parseInt(currentReview.rating || 0) ? 'filled' : ''}`}
//                 >
//                   ★
//                 </span>
//               ))}
//             </div>
//             <h3 className="customer-name">{currentReview.name}</h3>
//             {currentReview.reviewTitle && (
//               <h4 className="review-title">{currentReview.reviewTitle}</h4>
//             )}
//             <p className="customer-review">"{currentReview.review}"</p>
//           </div>
//         </div>

//         {reviews.length > 1 && (
//           <div className="nav-buttons-wrapper">
//             <button className="nav-button left" onClick={handlePrev}>
//               &lt;
//             </button>
//             <span className="review-counter">
//               {currentIndex + 1} / {reviews.length}
//             </span>
//             <button className="nav-button right" onClick={handleNext}>
//               &gt;
//             </button>
//           </div>
//         )}
//       </div>
//     </>
//   );
// };

// export default Customer;

import logo from "../Assets/fabhub-logo-nav.png";

import React, { useState, useEffect } from "react";
import "./Customer.css";
import HeaderTitle from "../HederTitle/HeaderTitle";
import axios from "axios";
import { backend_url } from "../../App";

const Customer = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fallbackImage = logo ;

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const response = await axios.get(`${backend_url}/api/testimonial?show=true`);
        const filteredReviews = response.data.filter(t => t.show !== false);
        setReviews(filteredReviews);
        setLoading(false);
      } catch (err) {
        setError("Failed to fetch reviews");
        setLoading(false);
        console.error("Error fetching testimonials:", err);
      }
    };

    fetchReviews();
  }, []);

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? reviews.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === reviews.length - 1 ? 0 : prevIndex + 1
    );
  };

  if (loading) return <div className="loading">Loading testimonials...</div>;
  if (error) return <div className="error">{error}</div>;
  if (reviews.length === 0) return <div className="no-reviews">No testimonials available</div>;

  const currentReview = reviews[currentIndex];
  const cap = (s = "") => s.charAt(0).toUpperCase() + s.slice(1);
  const hasPhoto = false;
  const initial = (currentReview.name || "A").charAt(0).toUpperCase();
  const rating = parseInt(currentReview.rating || 0);

  return (
    <section
      className="relative overflow-hidden px-4 sm:px-8 py-10"
      style={{ background: "linear-gradient(180deg, var(--brand-bg) 0%, var(--brand-surface) 100%)" }}
    >
      <HeaderTitle Header="What Customer's Say About Us" />

      <div className="relative max-w-3xl mx-auto mt-6">
        {/* Testimonial card — horizontal & compact */}
        <div className="relative bg-white rounded-2xl shadow-[0_10px_40px_rgba(124,58,237,0.10)] border border-[var(--brand-primary-100)] overflow-hidden">
          {/* Gradient accent strip (matches the review form header) */}
          <div className="h-1.5 w-full" style={{ background: "linear-gradient(90deg,#5B2B9E,#7A4CC0)" }} />
          <div className="p-6 sm:p-8 flex flex-col sm:flex-row items-center gap-6 sm:gap-8">
          {/* Left: reviewer */}
          <div className="flex flex-col items-center text-center flex-shrink-0 sm:w-44">
            {hasPhoto ? (
              <img
                loading="lazy"
                crossOrigin="anonymous"
                src={currentReview.reviewImage}
                alt={currentReview.name}
                onError={(e) => { e.target.src = fallbackImage; }}
                className="w-16 h-16 rounded-full object-cover ring-2 ring-[var(--brand-primary-100)] shadow-sm"
              />
            ) : (
              <div
                className="w-16 h-16 rounded-full flex items-center justify-center text-white text-2xl font-bold shadow-md"
                style={{ background: "linear-gradient(135deg,var(--brand-primary-600),var(--brand-primary-500))" }}
              >
                {initial}
              </div>
            )}
            <p className="font-bold text-gray-900 leading-tight mt-3">{cap(currentReview.name)}</p>
            {currentReview.city && (
              <p className="text-sm font-medium text-[var(--brand-primary-600)]">{cap(currentReview.city)}</p>
            )}
            <div className="flex gap-0.5 text-sm mt-2">
              {[...Array(5)].map((_, i) => (
                <span key={i} style={{ color: i < rating ? "#F59E0B" : "#E5E7EB" }}>★</span>
              ))}
            </div>
          </div>

          {/* Divider */}
          <div className="hidden sm:block w-px self-stretch bg-[var(--brand-primary-100)]" />
          <div className="sm:hidden h-px w-20 bg-[var(--brand-primary-100)]" />

          {/* Right: quote */}
          <div className="relative flex-1">
            <span
              className="text-5xl leading-none select-none pointer-events-none"
              style={{ fontFamily: "Georgia, serif", color: "#EDE4FB" }}
            >
              &ldquo;
            </span>
            <p className="text-lg sm:text-xl text-gray-700 leading-relaxed italic -mt-4 text-center sm:text-left">
              {currentReview.message}
            </p>
          </div>
          </div>
        </div>

        {/* Navigation */}
        {reviews.length > 1 && (
          <div className="flex items-center justify-center gap-4 mt-5">
            <button
              onClick={handlePrev}
              aria-label="Previous review"
              className="w-10 h-10 rounded-full border border-[var(--brand-primary-200)] text-[var(--brand-primary-600)] flex items-center justify-center hover:bg-[var(--brand-primary-600)] hover:text-white hover:border-[var(--brand-primary-600)] transition-colors"
            >
              &#8592;
            </button>

            <div className="flex items-center gap-1.5">
              {reviews.map((_, i) => (
                <button
                  key={i}
                  onClick={() => setCurrentIndex(i)}
                  aria-label={`Go to review ${i + 1}`}
                  className="rounded-full transition-all"
                  style={{
                    width: i === currentIndex ? 22 : 8,
                    height: 8,
                    background: i === currentIndex ? "linear-gradient(90deg,var(--brand-primary-600),var(--brand-primary-500))" : "#E5D6F6",
                  }}
                />
              ))}
            </div>

            <button
              onClick={handleNext}
              aria-label="Next review"
              className="w-10 h-10 rounded-full border border-[var(--brand-primary-200)] text-[var(--brand-primary-600)] flex items-center justify-center hover:bg-[var(--brand-primary-600)] hover:text-white hover:border-[var(--brand-primary-600)] transition-colors"
            >
              &#8594;
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default Customer;
